/**
 * @author benaadams / https://twitter.com/ben_a_adams
 * based on THREE.SphereGeometry
 */

InnerSphereGeometry = function ( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

	if (typeof THREE.BufferGeometry === 'function' && /^\s*class\s+/.test(THREE.BufferGeometry.toString())) {
		this.buffer = new THREE.BufferGeometry();
	} else {
		THREE.BufferGeometry.call( this );
	}

	this.type = 'InnerSphereGeometry';

	this.getMesh = function() {
		if (this.buffer == undefined) return this;
		else return this.buffer;

	}.bind(this);

	this.parameters = {
		radius: radius,
		widthSegments: widthSegments,
		heightSegments: heightSegments,
		phiStart: phiStart,
		phiLength: phiLength,
		thetaStart: thetaStart,
		thetaLength: thetaLength
	};

	radius = radius || 50;

	widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
	heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );

	phiStart = phiStart !== undefined ? phiStart : 0;
	phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;

	thetaStart = thetaStart !== undefined ? thetaStart : 0;
	thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;

	var thetaEnd = thetaStart + thetaLength;

	var vertexCount = ( ( widthSegments + 1 ) * ( heightSegments + 1 ) );

	var positions = new THREE.BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var normals = new THREE.BufferAttribute( new Float32Array( vertexCount * 3 ), 3 );
	var uvs = new THREE.BufferAttribute( new Float32Array( vertexCount * 2 ), 2 );

	var index = 0, vertices = [], normal = new THREE.Vector3();

//	console.log("Init buffers");

	var sx = 0; sy = 0; sz = 0;

	for ( var y = 0; y <= heightSegments; y ++ ) {

		var verticesRow = [];

		var v = y / heightSegments;

		for ( var x = 0; x <= widthSegments; x ++ ) {

			var u = x / widthSegments;

			var px = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
			var py = radius * Math.cos( thetaStart + v * thetaLength );
			var pz = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

			normal.set( px, py, pz ).normalize();

			positions.setXYZ( index, px, py, pz );
			normals.setXYZ( index, normal.x, normal.y, normal.z );
			uvs.setXY( index, 1 - u, 1 - v );

			verticesRow.push( index );

			index ++;

			sx += px; sy += py; sz += pz;
		}

		vertices.push( verticesRow );

	}

	sx = sx / index;
	sy = sy / index;
	sz = sz / index;

	if (this.buffer == undefined) {
		var indices = [];
	} else {
		var indices = new Uint32Array(6 * heightSegments * widthSegments);
	}

	var ind = 0;

	for ( var y = 0; y < heightSegments; y ++ ) {

		for ( var x = 0; x < widthSegments; x ++ ) {

			var v1 = vertices[ y ][ x + 1 ];
			var v2 = vertices[ y ][ x ];
			var v3 = vertices[ y + 1 ][ x ];
			var v4 = vertices[ y + 1 ][ x + 1 ];

			if (this.buffer == undefined) {
				if ( y !== 0 || thetaStart > 0 ) indices.push( v1, v2, v4 );
				if ( y !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( v2, v3, v4 );
			} else {
				if ( y !== 0 || thetaStart > 0 ) {
					indices[ind] = v1;
					indices[ind + 1] = v2;
					indices[ind + 2] = v4;
					//.push( v1, v2, v4 );
					ind += 3;
				}

				if ( y !== heightSegments - 1 || thetaEnd < Math.PI ) {
					indices[ind] = v2;
					indices[ind + 1] = v3;
					indices[ind + 2] = v4;
//					indices.push( v2, v3, v4 );				
					ind += 3;
				}				
			}

		}

	}

//	console.log("Before setting attributes");

	if (this.buffer == undefined) {
		this.setIndex( new ( positions.count > 65535 ? THREE.Uint32Attribute : THREE.Uint16Attribute )( indices, 1 ) );
		this.addAttribute( 'position', positions );
		this.addAttribute( 'normal', normals );
		this.addAttribute( 'uv', uvs );
	} else {
//		if (positions.count > 65535) this.buffer.setIndex( new THREE.Uint32Attribute( indices, 1 ));
//		else this.buffer.setIndex( new THREE.Uint16Attribute( indices, 1 ));

		this.buffer.setIndex(new THREE.BufferAttribute( indices, 1 ));

		this.buffer.setAttribute( 'position', positions );
		this.buffer.setAttribute( 'normal', normals );
		this.buffer.setAttribute( 'uv', uvs );
	}

//	console.log("Set attributes");

	//console.log(sy);
	if (Math.abs(sy) < 13)
		this.boundingSphere = new THREE.Sphere( new THREE.Vector3(sx, sy, sz), radius / 5 );
	else 
		this.boundingSphere = new THREE.Sphere( new THREE.Vector3(sx, sy, sz), radius / 4 );

//	console.log("Finish INIT inner sphere");
};

//THREE.InnerSphereGeometry.prototype = Object.create( THREE.BufferGeometry.prototype );
//THREE.InnerSphereGeometry.prototype.constructor = THREE.SphereBufferGeometry;